var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42639 0.552458C2.68195 0.806327 1.46338 1.62596 0.767058 3.01861C0.24844 4.05947 0.0779857 5.58269 0.360868 6.70333C0.63287 7.78409 1.2893 8.97727 2.29752 10.2321C3.54511 11.7807 5.46726 13.5723 7.63239 15.2043C7.99869 15.4799 9.30793 16.412 9.45662 16.5027C9.50739 16.5317 9.77214 16.354 10.7332 15.6431C13.3843 13.6738 15.6619 11.5268 17.0509 9.67722C18.3638 7.93278 18.9042 6.47485 18.7518 5.10034C18.4545 2.45647 16.2857 0.498056 13.6527 0.494431C12.2999 0.494431 11.0669 1.00217 10.0804 1.96324C9.93172 2.10831 9.74313 2.31141 9.66334 2.41295C9.58355 2.51087 9.51102 2.59429 9.50014 2.59429C9.48926 2.59429 9.41673 2.51087 9.33694 2.41295C8.70952 1.61508 7.68317 0.936888 6.68945 0.664886C6.08379 0.498056 5.12635 0.450911 4.42639 0.552458Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.15e43be42887cc3a142d59296ac041dd.svg";
export { ForwardRef as ReactComponent };